<template>
  <transition name="status-slide">
    <div v-if="visible" class="status-toast" :class="[`status-toast--${variant}`]">
      <div class="status-head">
        <div class="status-copy">
          <strong>{{ title }}</strong>
          <span v-if="message">{{ message }}</span>
          <span v-if="detail" class="status-detail">{{ detail }}</span>
        </div>
        <div v-if="mode === 'spinner'" class="status-spinner" aria-hidden="true"></div>
      </div>

      <div v-if="mode === 'progress'" class="status-progress">
        <div class="status-progress-bar" :style="{ width: `${progressValue}%` }"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'StatusToast',

  props: {
    message: {
      type: String,
      default: ''
    },
    detail: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'spinner'
    },
    progress: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'info'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    progressValue() {
      return Math.max(0, Math.min(100, Number(this.progress || 0)));
    }
  }
}
</script>

<style scoped>
.status-toast {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 1350;
  width: min(340px, calc(100vw - 36px));
  border-radius: 18px;
  border: 1px solid #50545d;
  background: rgba(34, 35, 38, 0.96);
  color: #f4f8ff;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.34);
  padding: 0.9rem 1rem;
  backdrop-filter: blur(8px);
}

.status-toast--success {
  border-color: #00f0ff;
  box-shadow: 0 0 20px rgba(0, 240, 255, 0.22);
}

.status-toast--error {
  border-color: #ff4d4d;
}

.status-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.9rem;
}

.status-copy {
  display: grid;
  gap: 0.2rem;
}

.status-copy strong {
  color: #00f0ff;
  font-size: 0.98rem;
}

.status-copy span {
  color: #d2d9e6;
  font-size: 0.88rem;
  line-height: 1.35;
}

.status-detail {
  color: #9fb0c9;
  font-size: 0.8rem;
}

.status-spinner {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.14);
  border-top-color: #00f0ff;
  animation: status-spin 0.82s linear infinite;
  flex: 0 0 auto;
}

.status-progress {
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
  margin-top: 0.8rem;
}

.status-progress-bar {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #00f0ff 0%, #7dfff2 100%);
  transition: width 0.16s ease;
}

.status-slide-enter-active,
.status-slide-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.status-slide-enter-from,
.status-slide-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

@keyframes status-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
